/**
 * FAQ Accordion Module
 * 
 * @package JD_Theme
 */

export function initFaqAccordion() {
  const faqItems = document.querySelectorAll('[data-faq-item]');
  
  if (!faqItems.length) {
    return;
  }

  faqItems.forEach(item => {
    const button = item.querySelector('.faq-item__question');
    const answer = item.querySelector('.faq-item__answer');
    
    if (!button || !answer) {
      return;
    }

    button.addEventListener('click', () => {
      const isActive = item.getAttribute('data-faq-active') === 'true';
      
      if (isActive) {
        // Close this item
        item.setAttribute('data-faq-active', 'false');
        button.setAttribute('aria-expanded', 'false');
      } else {
        // Close all other items
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.setAttribute('data-faq-active', 'false');
            const otherButton = otherItem.querySelector('.faq-item__question');
            if (otherButton) {
              otherButton.setAttribute('aria-expanded', 'false');
            }
          }
        });
        
        // Open this item
        item.setAttribute('data-faq-active', 'true');
        button.setAttribute('aria-expanded', 'true');
      }
    });

    // Keyboard accessibility
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        button.click();
      }
    });
  });
}
